"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HAS_WINDOW = void 0;

/**
 * returns if the window is defined, used for determining browser vs node
 */
var HAS_WINDOW = typeof window !== 'undefined';
exports.HAS_WINDOW = HAS_WINDOW;
//# sourceMappingURL=has-window.js.map